import React, { useContext } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from './context/AuthContext';
import Auth from './components/Auth';
import ProjectList from './components/ProjectList';
import ProjectDashboard from './components/ProjectDashboard';
import GlossaryUpload from './components/GlossaryUpload';
import InstructionsEditor from './components/InstructionsEditor';
import DocumentView from './components/DocumentView';
import './styles/global.css';
import Header from './components/Header';
import Navigation from './components/Navigation'; // Import Navigation

// Protected route component remains unchanged
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return (
        <div className="flex justify-center items-center min-h-screen bg-gray-50">
             <div className="loading">Authenticating...</div>
        </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return children;
};

// Updated LayoutContent to include Navigation
const LayoutContent = ({ children }) => {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
  
  // Extract project ID for Navigation
  const getProjectId = () => {
    const match = location.pathname.match(/\/projects\/([^\/]+)/);
    return match ? match[1] : null;
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {user && <Header />} {/* The fixed header */}
      {user && !isLoginPage && <Navigation projectId={getProjectId()} />} {/* Add Navigation */}
      <div className={isLoginPage ? '' : 'main-content-area'}>
        {children} {/* The page content */}
      </div>
    </div>
  );
};

// App function remains unchanged
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/*" element={
          <LayoutContent>
            <Routes>
              <Route path="/login" element={<Auth />} />
              <Route path="/projects/:projectId/glossary" element={
                <ProtectedRoute>
                  <GlossaryUpload />
                </ProtectedRoute>
              } />
              <Route path="/projects/:projectId/instructions" element={
                <ProtectedRoute>
                  <InstructionsEditor />
                </ProtectedRoute>
              } />
              <Route path="/projects/:projectId" element={
                <ProtectedRoute>
                  <ProjectDashboard />
                </ProtectedRoute>
              } />
              <Route path="/documents/:documentId" element={
                <ProtectedRoute>
                  <DocumentView />
                </ProtectedRoute>
              } />
              <Route path="/" element={
                <ProtectedRoute>
                  <ProjectList />
                </ProtectedRoute>
              } />
            </Routes>
          </LayoutContent>
        } />
      </Routes>
    </Router>
  );
}

export default App;